import './checkboxDropdown.lib'
import './checkboxDropdown.styles.scss'

export const initCheckboxDropdown = () => {
  document.multiselect('[data-multiselect]')
}
